import TaskStatus from "./task-status"
import Collection from "../../data-structures/collection"
import {SystemStatus} from "../../gd/const/system-status";

export default class TaskStatusesCollection extends Collection<TaskStatus> {

    static initFromJson(data:JSONArray):TaskStatusesCollection {
        const collection = new TaskStatusesCollection([])

        _.map(data, (record:JSONObject)=>{
            collection.add(new TaskStatus(record))
        })

        collection.sort()

        return collection
    }

    /*comparator(m) {
        if (m.status) {
            return m.systemStatus*100+m.sortPosition;
        } else {
            return m.sortPosition;
        }
    },*/

    // Old (System status + sort position)
    sortBySystemStatus() {
        const SYSTEM_STATUSES_ORDER = [
            SystemStatus.NOT_STARTED,
            SystemStatus.IN_PROGRESS,
            SystemStatus.IN_REVIEW,
            SystemStatus.ON_HOLD,
            SystemStatus.COMPLETED,
            SystemStatus.CANCELLED
        ]

        this.models = _.sortBy(this.models, (model: TaskStatus)=> {
            const index = SYSTEM_STATUSES_ORDER.indexOf(model.systemStatus)
            return index < 0 ? SYSTEM_STATUSES_ORDER.length : index
        })

        return this
    }

    // New (Sort position, system status only to break ties)
    // sortPosition is a global index across the whole collection (see saveSortPositions /
    // sortGlist), so statuses can be ordered arbitrarily, independent of their system status.
    //
    // A status that has never been reordered keeps the default sortPosition of 0 - see the same
    // note in TaskStatusesLookup.getDefaultTasksStatuses(). On a task type nobody has dragged yet
    // every position is 0, so system status breaks the tie and the statuses keep the grouped order
    // they had before. Once dragged, the positions are distinct and the tie breaker never applies.
    sort() {
        this.models = _.orderBy(this.models, [
            (model:TaskStatus) => model.sortPosition || 0,
            (model:TaskStatus) => model.systemStatus
        ])
    }

    getByStatusId(statusId: ID) {
        return _.find(this.models, (model:TaskStatus)=>model.status.id == statusId)
    }

    findBySystemStatus(arrStatuses: ID[]) {
        return _.filter(this.models, (model:TaskStatus) => arrStatuses.includes(model.status.systemStatus))
    }

    filterOpenStatuses() {
        const filteredModels: TaskStatus[] = _.filter(this.models, (model:TaskStatus) => gd.const.systemStatus.isOpen(model.systemStatus)) as TaskStatus[]

        const collection = new TaskStatusesCollection()
        collection.reset(filteredModels)
        collection.sort()

        return collection
    }

    exportToOptions() {
        return _.map(this.models, (model:TaskStatus) => {
            return {
                value       : model.status.id,
                label       : model.status.name,
                // colorClass: 'status-color-'+model.status.color,
                color       : model.status.color,
                systemStatus: model.status.systemStatus
            }
        })
    }
}
